import { styled } from '@mui/system';
import { memo } from 'react';

interface NotificationProps {
  color?: string;
  isFlashes?: boolean;
}

const NotificationAllertStyle = styled('div')<NotificationProps>(({ theme, isFlashes, color }) => ({
  width: '30px',
  height: '30px',
  background: theme.palette[color || 'primary'].main,
  borderRadius: '50%',
  margin: 'auto',
  animation: 'circle 1s linear infinite',
  '@keyframes circle': {
    '0%': {
      opacity: isFlashes ? 0.3 : 1,
    },
    '50%': {
      opacity: isFlashes ? 0.6 : 1,
    },
    '100%': {
      opacity: 1,
    },
  },
}));

const NotificationAllertComponent = ({
  color,
  isFlashes = false,
}: NotificationProps): React.ReactElement => {
  return <NotificationAllertStyle color={color} isFlashes={isFlashes} />;
};

NotificationAllertComponent.displayName = 'Notification Allert Component';

const NotificationAllert = memo(NotificationAllertComponent);

export default NotificationAllert as unknown as typeof NotificationAllertComponent;
